var TriggerPageLeaveStrategy = /** @class */ (function () {
    function TriggerPageLeaveStrategy() {
        this._canOpen = true;
        this._shown = false;
    }
    TriggerPageLeaveStrategy.prototype.register = function (callback, timeout) {
        var _this = this;
        var timeoutExpired = false;
        var timer = window.setTimeout(function () {
            timeoutExpired = true;
        }, timeout);
        var ua = navigator.userAgent;
        var triggerCallback = function () {
            if (!_this._shown && _this._canOpen && timeoutExpired) {
                callback();
                window.clearTimeout(timer);
            }
        };
        document.documentElement.addEventListener('mouseleave', function (e) {
            if ((ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1) || e.clientY <= 0) {
                triggerCallback();
            }
        });
    };
    TriggerPageLeaveStrategy.prototype.destroy = function (timeout) {
        var _this = this;
        this._shown = false;
        this._canOpen = false;
        if (isNaN(timeout)) {
            return;
        }
        setTimeout(function () {
            _this._canOpen = true;
        }, timeout);
    };
    return TriggerPageLeaveStrategy;
}());
export { TriggerPageLeaveStrategy };
